import { render, staticRenderFns } from "./HostedPaymentEdit.vue?vue&type=template&id=05aff748&"
import script from "./HostedPaymentEdit.vue?vue&type=script&lang=ts&"
export * from "./HostedPaymentEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports